/**
 * The custom donation pop-up element.
 * Uses the donation.js module to handle the donation form.
 */

if (!customElements.get('donation-pop-up')) {

  class DonationPopUp extends HTMLElement {
    constructor() {
      super();

      // Init the close events
      this.querySelector('[data-close-button]').addEventListener('click', () => this.toggle(false));
      this.querySelector('[data-overlay]').addEventListener('click', () => this.toggle(false));
    }

    /**
     * Toggle the donation pop-up.
     * @param {boolean} open - Whether to open or close the pop-up.
     */
    toggle(open) {
      this.classList.toggle('donation-pop-up-is-open', open);
    }

  }

  window.DonationModule = DonationPopUp;
  customElements.define('donation-pop-up', DonationPopUp);

}
